module.exports = __webpack_public_path__ + "img/40_69_012_040.f11fbeb7.jpg";